import StatsController from './stats.controller.js';

let userLoadedSubscribe, toastSubscribe, errorSubscribe;

class ToolbarController{
    /*@ngInject*/
    constructor(EventService,$mdDialog,SessionService,UserService,$mdToast, $state){
        this.event = EventService;
        this.session = SessionService;
        this.userService = UserService;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.$state = $state;
    }
    $onInit(){
        this.loggedIn = false;
        if(this.userService.isValid() === false) {
            userLoadedSubscribe = this.event.subscribe('user:loaded', () => {
                this.loggedIn = true;
                this.user = this.userService.getUser();
            });
        }else{
            this.user = this.userService.getUser();
            this.loggedIn = true;
        }
        toastSubscribe = this.event.subscribe('toast.message', data=>{
            this.$mdToast.show(
                this.$mdToast.simple()
                    .textContent(data)
                    .highlightAction(false)
                    .position('top left')
                    .hideDelay(10000)
            );
        });
        errorSubscribe = this.event.subscribe('websocket:error',()=>{
            this.$state.go("error");
        });
    }
    $onDestroy(){
        userLoadedSubscribe();
        toastSubscribe();
        errorSubscribe();
    }
    launchModal(event){
        if(!this.loggedIn){
            return false;
        }
        this.$mdDialog.show({
            controller: StatsController,
            bindToController:true,
            controllerAs:'$ctrl',
            template: require('./stats.template.html'),
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose:true,
            fullscreen: true
        })
        .then(function(answer) {

        }, function() {

        });
    }
}

export default ToolbarController;


// WEBPACK FOOTER //
// ./public/app/toolbar/toolbar.controller.js